import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { QRPass } from "@/lib/QRPass";
import { Citr } from "@/sergecych.uni3/Citr";
import { defaultCitr } from "@/lib/globals";

Vue.config.productionTip = false;

// this will start catching logs
defaultCitr();

Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function(el) {
    // Focus the element
    el.focus();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// Initialize slow background preparations
// localStorage.clear();
// localStorage.removeItem("login");
// localStorage.removeItem("password");
QRPass.initialize();
